import { ReactNode, useLayoutEffect, useRef } from 'react';
import {
  resetNavigationHeaderBannerHeight,
  setNavigationHeaderBannerHeight,
} from 'shared/layout/NavigationHeaderBannerHeight';
import styled from 'styled-components';

const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 1300;
`;

interface NavigationHeaderBannerContainerProps {
  children: ReactNode;
}

export function NavigationHeaderBannerContainer({
  children,
}: NavigationHeaderBannerContainerProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = containerRef.current!;

    function updateBannerHeight() {
      if (!containerRef.current) {
        return;
      }

      setNavigationHeaderBannerHeight(containerRef.current.offsetHeight);
    }

    updateBannerHeight();

    if (typeof ResizeObserver === 'undefined') {
      return () => {
        resetNavigationHeaderBannerHeight();
      };
    }

    const resizeObserver = new ResizeObserver(updateBannerHeight);
    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
      resetNavigationHeaderBannerHeight();
    };
  }, []);

  return <Container ref={containerRef}>{children}</Container>;
}
